module.exports = __webpack_public_path__ + "img/card_ip_stipulation42_1.049731a0.svg";